import HOST from "../constants/Host";
require('es6-promise').polyfill();
require('isomorphic-fetch');

const HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

export default (url, method = 'GET', request = {}) => {

  const body = method === 'GET' ? null : JSON.stringify(request);

  const payload = {
    method,
    credentials: 'include',
    headers: HEADERS,
    body
  };

  return fetch(HOST + url, payload)
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }

      if(response.status === 204) {
        return Promise.resolve({});
      }

      return Promise.reject(response);
    });
};
